/**
 * Collection banner — “Show more” only when description overflows (line clamp).
 */
(function () {
  var resizeTimer;

  document.querySelectorAll('[data-collection-banner-desc-root]').forEach(function (root) {
    var inner = root.querySelector('.collection-banner__desc-inner');
    var btn = root.querySelector('.collection-banner__desc-toggle');
    var labelSpan = root.querySelector('.collection-banner__desc-toggle-text');
    if (!inner || !btn || !labelSpan) return;

    var more = btn.getAttribute('data-label-more') || '';
    var less = btn.getAttribute('data-label-less') || '';

    function sync() {
      var expanded = inner.classList.contains('is-expanded');

      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (!expanded) {
        labelSpan.textContent = more;
      }

      btn.hidden = true;

      requestAnimationFrame(function () {
        if (expanded) {
          btn.hidden = false;
          return;
        }
        var overflowing = inner.scrollHeight > inner.clientHeight + 2;
        btn.hidden = !overflowing;
      });
    }

    btn.addEventListener('click', function () {
      var expanding = !inner.classList.contains('is-expanded');
      inner.classList.toggle('is-expanded', expanding);
      labelSpan.textContent = expanding ? less : more;
      sync();

      /* Second frame helps after collapsing so clamp is applied before measuring */
      if (!expanding) {
        requestAnimationFrame(sync);
      }
    });

    window.addEventListener(
      'resize',
      function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(sync, 120);
      },
      { passive: true },
    );

    sync();
    requestAnimationFrame(sync);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        sync();
        requestAnimationFrame(sync);
      });
    }
  });
})();
